import React, { useState, useEffect, useRef } from "react";
import "./ChatbotModal.css";

const ChatbotModal = ({ isOpen, onClose }) => {
  const [isLoading, setIsLoading] = useState(true);
  const chatbotRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    // Reset loading state when modal opens
    setIsLoading(true);

    // Create a MutationObserver to watch for changes in the chatbot element
    const observer = new MutationObserver((mutations) => {
      // Check if the chatbot has any content or if it's fully rendered
      const chatbot = chatbotRef.current;
      if (chatbot && chatbot.shadowRoot) {
        setIsLoading(false);
        observer.disconnect();
      }
    });

    // Start observing the chatbot element
    if (chatbotRef.current) {
      observer.observe(chatbotRef.current, {
        childList: true,
        subtree: true,
        attributes: true,
      });
    }

    // Cleanup observer on unmount or when modal closes
    return () => {
      observer.disconnect();
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="chatbot-modal-overlay">
      <div className="chatbot-modal-content">
        <button className="chatbot-close-button" onClick={onClose}>
          &times;
        </button>
        <div className="chatbot-container">
          {isLoading && (
            <div className="chatbot-loading">
              <div className="loading-spinner"></div>
              <p>Loading chatbot...</p>
            </div>
          )}
          <zapier-interfaces-chatbot-embed
            ref={chatbotRef}
            is-popup="false"
            chatbot-id="clyi737ft0018463a0e3sn3cq"
            height="600px"
            width="100%"
          ></zapier-interfaces-chatbot-embed>
        </div>
      </div>
    </div>
  );
};

export default ChatbotModal;
